import { array } from 'prop-types'
import { connect } from 'react-redux'
import { selectors } from '@opallabs/wormhole'
import PersonMultiSelect from '.'

export const PeoplePickerComponent = ({ people = [], ...otherProps }) => (
  <PersonMultiSelect
    {...otherProps}
    avatared={true}
    options={people}
    optionsType="users"
  />
)

PeoplePickerComponent.propTypes = {
  people: array,
}

const mapStateToProps = (state) => {
  const users = selectors.selectUsersToArray(state)
  const people = users.map((person) => ({
    id: parseInt(person.id, 10),
    title: `${person.first_name} ${person.last_name}`,
    icon: 'person',
  }))

  return { people }
}

const mapDispatchToProps = {}

const ConnectedPeoplePicker = connect(
  mapStateToProps,
  mapDispatchToProps
)(PeoplePickerComponent)

export default ConnectedPeoplePicker
